import SiafLiteApiRepository from "../../external/siaf-lite-api-form-data";

class StorageService {
  constructor() {
    this.urlBase = "/storage";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  addImage(formData) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(formData);
  }

  addImageTemp(formData) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/temp`).post(
      formData
    );
  }

  addImages(formData) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/lista`).post(
      formData
    );
  }

  removeImage(nome) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(nome);
  }
}

export default StorageService;
